<footer class="footer bg-info mt-4 d-none d-md-block">
    
  <div class="container">
    <div class="row">

      <div class="col-lg-7">
        <div class="row justify-content-center">
          <div class=" text-center mx-auto my-auto">
            <div class="p-3 warning-horizontal justify-content-center">
              <img class="avatar-xxl" src="/img/logo.svg" alt="">
              <p class="text-white my-auto font-weight-bold">SENA Empresa vitrina web</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-sm-12 mx-auto my-auto justify-content-center">
        <h5 class="text-edo text-success ps-3">Contacto</h5>
          <ul class="flex-column nav mt-3 border ps-3">
            <li class="nav-item text-white mt-n3">
              <span class="bg-info px-2">Centro Biotecnológico del Caribe</span>
            </li>
            <li class="nav-item ">
              <a class="text-white" href="https://maps.app.goo.gl/Y6UjHDGMeguajzfi6" target="_blank">Ubicación: Km 7 via la paz</a>
            </li>
            <li class="nav-item text-white mb-2">
              correo: vitrinaweb@sena.edu.co
            </li>
          </ul>
      </div>

      <div class="col-12 my-2 pt-1 border-top border-white text-center">
        <a href="/" class="text-sm text-white">Programmed by <span class="link-success">Sebastian Pitre.</span> </a>
      </div>
    </div>
  </div>
</footer>